//门户导航
import { pbService } from "./manage";
export default {
    /**
     * 请求栏目下文章列表
     * @param {*} userInfo 用户信息
     * @param {*} column_uuid 当前栏目id
     * @param {*} page 页码
     * @param {*} rows 行数
     * @param {*} result_fields 返回字段
     * @param {*} order_fields  排序条件
     */
    reqNewList: function(
        userInfo,
        column_uuid,
        page,
        rows,
        result_fields,
        order_fields,
        query_fields = {}
    ) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webCmsService", "pageQueryByAttr", {
                user_info: userInfo,
                column_uuid: column_uuid,
                pageInfo: {
                    page: page, //"1",
                    rows: rows //"1"
                },
                query_fields: query_fields,
                result_fields: result_fields, // "main_uuid,title,subtitle,publish_time",
                order_fields: order_fields //"istop desc, publish_time desc"
            }).then(res => {
                resolve(res);
            });
        });
    },
    /**
     * 请求栏目下子栏目
     * @param {*} userInfo 用户信息
     * @param {*} column_uuid 当前栏目id
     * @param {*} result_fields 返回字段
     * @param {*} order_fields  排序条件
     */
    reqColmsList: function(userInfo, query_fields, result_fields, order_fields) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webColumnService", "queryChildColumn", {
                user_info: userInfo,
                query_fields: query_fields,
                result_fields: result_fields, // "main_uuid,title,subtitle,publish_time",
                order_fields: order_fields //"istop desc, publish_time desc"
            }).then(res => {
                resolve(res);
            });
        });
    },
    /**
     * 请求栏目信息
     * @param {*} userInfo 用户信息
     * @param {*} column_uuid 当前栏目id
     * @param {*} result_fields 返回字段
     * @param {*} order_fields  排序条件
     */
    reqColmsInfo: function(userInfo, query_fields, result_fields, order_fields) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webColumnService", "queryByAttr", {
                user_info: userInfo,
                query_fields: query_fields,
                result_fields: result_fields, // "main_uuid,title,subtitle,publish_time",
                order_fields: order_fields //"istop desc, publish_time desc"
            }).then(res => {
                resolve(res);
            });
        });
    },
    /**
     * 请求站点下所有页面信息
     * @param {*} site_path 站点路径
     */
    reqPagesInfo: function(site_path) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webPageService", "queryByAttr", {
                query_fields: {
                    site_path: site_path,
                    is_site: "0",
                    is_show: "1"
                },
                result_fields: "page_name,page_uuid,page_path,page_router,page_type,page_typename",
                order_fields: ""
            }).then(res => {
                resolve(res);
            });
        });
    },
    /**
     * 请求获取站点信息
     * @param {*} site_path 站点路径
     */
    reqSiteInfo: function(site_path) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webSiteService", "queryByPath", {
                    site_path: site_path,
                    result_fields: "site_name,site_uuid,site_type,site_typename,site_path,site_router,theme_type,header_logo_uuid,header_height,header_width"
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    /**
     * 请求页面下所有悬浮图片
     * @param {*} page_uuid 页面标识
     */
    reqHoverPics: function(page_uuid) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webPopupImgService", "queryByAttr", {
                query_fields: {
                    page_uuid: page_uuid
                },
                result_fields: "popup_uuid,title,file_uuid,img_width,img_height,speed,href_url,overdue_time,page_uuid",
                order_fields: ""
            }).then(res => {
                resolve(res);
            });
        });
    },

    /**
     * 请求目标站点下目标页面中所有的组件信息
     * @param {*} userInfo 用户信息
     * @param {*} column_uuid 当前页面id
     * @param {*} station 当前站点路径
     * @param {*} result_fields 返回字段
     * @param {*} order_fields  排序条件
     */
    getAllColmsOfPage: function(
        userInfo,
        column_uuid,
        station,
        result_fields,
        order_fields
    ) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webCmsService", "pageQueryByAttr", {
                user_info: userInfo,
                column_uuid: column_uuid,
                station: station, //"/"
                query_fields: {},
                result_fields: result_fields, // "main_uuid,title,subtitle,publish_time",
                order_fields: order_fields //"istop desc, publish_time desc"
            }).then(res => {
                resolve(res);
            });
        });
    },
    /**
     * 请求目标站点下所有页面的信息
     * @param {*} station 当前站点路径
     */
    reqHeaderOfStation: function(station) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webPageService", "queryByAttr", {
                    query_fields: {
                        site_path: station,
                        is_site: "0",
                        is_show: "1"
                    },
                    result_fields: "page_name,page_uuid,page_path,parent_uuid,page_router,page_type,page_typename,display_order,page_note,status",
                    order_fields: ""
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
  },
    
    // 层级改变，请求目标站点下所有页面的信息
  reqHeaderOfStation2: function(station) {
    return new Promise((resolve, reject) => {
        pbService("service.egw.webPageService", "queryPageTree", {
                query_fields: {
                    site_path: station,
                    is_site: "0",
                    is_show: "1"
                },
                result_fields: "page_name,page_uuid,page_path,parent_uuid,page_router,page_type,page_typename,display_order,page_note,status,child",
                order_fields: ""
            })
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err);
            });
    });
},
    /**
       * 请求目标站点下的计数器列表
      
       * @param {*} station 当前站点路径
       */
    reqCounterOfStation: function(station) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webCounterService", "queryByAttr", {
                    query_fields: {
                        site_path: station
                    },
                    result_fields: "counter_uuid,title,page_uuid",
                    order_fields: ""
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    /**
     * 计数器+1
     *   @param {*} userInfo 用户信息
     * @param {*} counter_uuid 当前计数器标识
     */
    counterAdd: function(userInfo, counter_uuid) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webCounterService", "increaseCounterDay", {
                    DATA: {
                        user_info: userInfo
                    },
                    counterday_info: {
                        counter_uuid: counter_uuid
                    }
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    /**
     * 计数器总数
     * @param {*} counter_uuid 当前计数器标识
     */
    counterSum: function(counter_uuid) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webCounterService", "siteVisitContent", {
                    query_fields: {
                        counter_uuid: counter_uuid,
                        visitContent: "totalNumber"
                    }
                })
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    /**
     * 请求图片栏目下文章列表
     * @param {*} userInfo 用户信息
     * @param {*} column_uuid 当前栏目id
     * @param {*} page 页码
     * @param {*} rows 行数
     * @param {*} result_fields 返回字段
     * @param {*} order_fields  排序条件
     */
    reqImgNewList: function(userInfo, column_uuid, page, rows, order_fields) {
        return new Promise((resolve, reject) => {
            pbService("service.egw.webCmsService", "pageQueryImgListByAttr", {
                user_info: userInfo,
                column_uuid: column_uuid,
                pageInfo: {
                    page: page, //"1",
                    rows: rows //"1"
                },
                query_fields: {},
                // "result_fields":result_fields,// "main_uuid,title,subtitle,publish_time",
                order_fields: order_fields //"istop desc, publish_time desc"
            }).then(res => {
                resolve(res);
            });
        });
    },
    /**
     * 门户文章详情
     * @param {*} userInfo 用户信息
     * @param {*} main_uuid 文章id
     * @param {*} result_fields 返回的字段
     */
    reqArticalDetail: function(userInfo, main_uuid, result_fields) {
        return new Promise(r => {
            pbService("service.egw.webCmsService", "queryById", {
                user_info: userInfo,
                main_uuid: main_uuid,
                result_fields: result_fields //"main_uuid,column_uuid,title,subtitle,publish_time,content"
            }).then(res => {
                r(res);
            });
        });
    },

    /**
     * 请求导航类型下link_uuid 下的表
     * @param {*} pageInfo
     * @param {*} link_uuid
     * @param {*} resultFields
     * @param {*} orderFields
     */
    reqAkindOfTypeList: function(pageInfo, link_uuid, resultFields, orderFields) {
        return new Promise(r => {
            pbService("service.egw.webNavService", "queryNavList", {
                pageInfo: pageInfo,
                queryFields: {
                    type_uuid: link_uuid
                },
                resultFields: resultFields,
                orderFields: orderFields
            }).then(res => {
                r(res);
            });
        });
    },
    /**
     * 门户加载 局领导成员？？？？
     * @param {*} userInfo
     * @param {*} column_uuid
     */
    reqQueryListWithImg: function(userInfo, column_uuid) {
        return new Promise(r => {
            pbService("service.egw.webCmsService", "queryListWithImg", {
                user_info: userInfo,
                query_fields: {
                    column_uuid: column_uuid
                }
            }).then(res => {
                r(res);
            });
        });
    },
    /**
     * 根据栏目父节点请求子栏目
     * @param {*} userInfo
     * @param {*} parent_uuid
     * @param {*} result_fields
     * @param {*} order_fields
     */
    queryChildColumn: function(
        userInfo,
        parent_uuid,
        result_fields = "column_uuid,column_name,site_uuid,parent_uuid",
        order_fields = "display_order"
    ) {
        return new Promise(r => {
            pbService("service.egw.webColumnService", "queryChildColumn", {
                user_info: userInfo,
                query_fields: {
                    parent_uuid: parent_uuid
                },
                result_fields: result_fields,
                order_fields: order_fields
            }).then(res => {
                r(res);
            });
        });
    }
};